<template>
    <card :title="formTitle">
        <form @submit.prevent="submit" @keydown="form.onKeydown($event)">
            <notifications position="right top"/>

            <div class="form-group row">
                <label class="col-md-3 col-form-label text-md-right">{{ $t('title') }}</label>
                <div class="col-md-7">
                    <input v-model="form.title"
                           type="text"
                           name="title"
                           class="form-control"
                           required
                           minlength="5"
                           :class="{ 'is-invalid': form.errors.has('title') }"
                           :title="$t('title')">
                    <has-error :form="form" field="title"></has-error>
                </div>
            </div>

            <div class="form-group row">
                <label class="col-md-3 col-form-label text-md-right">{{ $t('sub_description') }}</label>
                <div class="col-md-7">
                    <textarea v-model="form.description"
                              name="description"
                              class="form-control"
                              :class="{ 'is-invalid': form.errors.has('description') }"></textarea>
                    <has-error :form="form" field="description"></has-error>
                </div>
            </div>

            <div class="form-group row">
                <label class="col-md-3 col-form-label text-md-right">{{ $t('position') }}</label>
                <div class="col-md-7">
                    <input v-model="form.pos"
                           type="number"
                           name="pos"
                           class="form-control"
                           required
                           :class="{ 'is-invalid': form.errors.has('pos') }"
                           :title="$t('position')">
                    <has-error :form="form" field="pos"></has-error>
                </div>
            </div>

            <div class="form-group row">
                <label class="col-md-3 col-form-label text-md-right">{{ $t('days') }}</label>
                <div class="col-md-7">
                    <input v-model="form.days"
                           type="number"
                           name="days"
                           class="form-control"
                           required
                           minlength="1"
                           :class="{ 'is-invalid': form.errors.has('days') }"
                           :title="$t('days')">
                    <has-error :form="form" field="days"></has-error>
                </div>
            </div>

            <div class="form-group row">
                <label class="col-md-3 col-form-label text-md-right">{{ $t('active') }}</label>
                <div class="col-md-7">
                    <toggle-button :value="form.active"
                                   :color="colorToggle"
                                   :sync="true"
                                   :labels="labelToggle"
                                   :width="50"
                                   @change="changeIsActive"/>
                    <has-error :form="form" field="active"></has-error>
                </div>
            </div>

            <!-- Submit Button -->
            <div class="form-group row">
                <div class="col-md-9 ml-md-auto">
                    <v-button type="success" :loading="form.busy">{{ $t('save') }}</v-button>
                </div>
            </div>
        </form>

    </card>
</template>

<script>
    import Form from 'vform';
    import {mapGetters} from 'vuex';
    import ToggleButton from 'vue-js-toggle-button';
    import _ from 'lodash';

    export default {
        name: "",

        props: {
            id: {
                type: String,
                default: function () {
                    return undefined;
                }
            }
        },

        components: {
            //
        },

        data: function () {
            return {
                form: new Form({
                    title: '',
                    description: '',
                    days: '1',
                    pos: '0',
                    active: true
                }),
                labelToggle: {
                    checked: 'Так',
                    unchecked: 'Ні'
                },
                colorToggle: {
                    checked: '#007bff',
                    unchecked: '#007bff'
                }
            }
        },

        async created() {
            await this.$store.dispatch('getSubscriptions');

            if(this.id) {
                this.$store.dispatch('getSubscriptionById', this.id);

                this.form.keys().forEach(key => {
                    if (key === 'active') {
                        this.form[key] = this.getSubscriptionById[key] == 1;
                    } else {
                        this.form[key] = this.getSubscriptionById[key];
                    }
                });
            }
        },

        computed: {
            ...mapGetters({
                getSubscriptions: 'getSubscriptions',
                getSubscriptionById: 'getSubscriptionById'
            }),

            subscriber() {
                return this.getSubscriptionById();
            },

            formTitle() {
                return !this.id ? 'Створення підписки' : 'Редагування підписки';
            }
        },

        methods: {
            changeIsActive(data) {
                this.form.active = data.value;
            },

            async submit() {
                if (!this.id) {
                    const {data} = await this.form.post('/api/libraries/subscriptions');
                    await this.$store.dispatch('saveSubscription', data);
                } else {
                    const {data} = await this.form.patch('/api/libraries/subscriptions/' + this.id);
                    await this.$store.dispatch('updateSubscription', data);
                }

                this.$notify({
                    title: '',
                    type: 'success',
                    text: (!this.id ? 'Підписка була збережена!' : 'Підписка була змінена!')
                });

                setTimeout(() => {
                    this.$router.push({name: 'user.subscriptions'});
                }, 1500);
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/subscriptions/form.vue